import {FrontBox} from "./FrontBox/FrontBox";
import LoginBox from "./FrontBox/LoginBox/LoginBox";
import WelcomeText from "./FrontBox/WelcomeText/WelcomeText";
import FrontInfoBoxes from "./FrontInfoBoxes/FrontInfoBoxes";
import classes from "./FrontPage.module.scss";
import MethodInfo from "./MethodInfo";
import {FrontHeader} from "./FrontHeader/FrontHeader";
import FrontMoreButton from "./FrontBox/FrontMoreButton/FrontMoreButton";
import {useRef} from "react";

const FrontPage = () => {
    const moreInfoRef = useRef<HTMLHeadingElement>(null);
    let moreInfoClickedHandler = ()=>{
        moreInfoRef?.current?.scrollIntoView();
    };
    return (
    <div>
        <FrontHeader/>
        <div className={classes.FeaturedTop}>
            <FrontBox/>
            <div className={classes.FrontInfo}>
                <WelcomeText/>
                <LoginBox/>
                <FrontMoreButton clicked={moreInfoClickedHandler}/>
            </div>
            {/*<SignIn/>*/}
        </div>
        <div ref={moreInfoRef} className={classes.FeaturedBottom}>
            <FrontInfoBoxes/>
        </div>
        <div ><MethodInfo/></div>
    </div>
)};

export default FrontPage;
